export const PAGINATION_LIMIT = 50;

export const AUTH_TOKEN = "auth_token";
export const AUTH_USER = "auth_user";
export const ROUTES = {
  HOME: "/home",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  SETTINGS: "/profile",
};

export const PASSWORD_REGEX =
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,})";

export const SORTING_ORDER = {
  ASC: "asc",
  DESC: "desc",
};

export const STATUS_CODE = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  SERVER_ERROR: 500,
};

export const LAYER_COLORS = [
  "#6565EC",
  "#D65DB1",
  "#FF8066",
  "#FFC75F",
  "#00C9A7",
  "#009EFA",
];

export enum UserGuides {
  "UploadShot" = "UploadShot",
  "SelectShot" = "SelectShot",
  "CreateAnnotation" = "CreateAnnotation",
  "HoverObject" = "HoverObject",
  "ClickObject" = "ClickObject",
  "ExitAnnotation" = "ExitAnnotation",
  "RunInference" = "RunInference",
  "FirstLayer" = "FirstLayer",
  "FirstCutout" = "FirstCutout",
  "AddKeyframe" = "AddKeyFrame",
  "FirstKeyframe" = "FirstKeyframe",
  "SecondKeyframe" = "SecondKeyframe",
  "RunTrackingInference" = "RunTrackingInference",
  "SelectService" = "SelectService",
  "AddRetime" = "AddRetime",
  "FirstRetime" = "FirstRetime",
  "CreateDepthMap" = "CreateDepthMap",
  "FirstDepthMap" = "FirstDepthMap",
  "CreateSmartVectors" = "CreateSmartVectors",
  "FirstSmartVectors" = "FirstSmartVectors",
  "SmartVectorsGenerating" = "SmartVectorsGenerating",
  "SmartVectorsError" = "SmartVectorsError",
  "SmartVectorsNewFeature" = "SmartVectorsNewFeature",
  "SmartVectorsAddRoi" = "SmartVectorsAddRoi",
  "SmartVectorsGenerate" = "SmartVectorsGenerate",
  "TrackingOutputGuide" = "TrackingOutputGuide",
  "SmartVectorsOutputGuide" = "SmartVectorsOutputGuide",
  "AddMoreAnnotations" = "AddMoreAnnotations",
  "AddMoreAnnotationsAfterInference" = "AddMoreAnnotationsAfterInference",
  "FreeTrial" = "FreeTrial",
}

export enum ViewModes {
  "Preview" = "Preview",
  "List" = "List",
}

export const DEFAULT_FPS = 24;

export enum STATUSES {
  "FAILED" = "FAILED",
  "IN_PROGRESS" = "IN_PROGRESS",
  "COMPLETED" = "COMPLETED",
}

export enum SERVICES {
  ROTOSCOPING = "Rotoscoping",
  RETIME = "Retime",
  DEPTH_MAP = "Depth Map",
  TRACKING = "Tracking",
  SMART_VECTORS = "Smart Vectors",
}

export enum EXPORT_MODES {
  EXR_MODE = "EXR",
  JPG_MODE = "JPG",
  MOV_MODE = "MOV",
}

export enum DEPTH_MAP_EXPORT_MODES {
  JPG_MODE = "JPG",
  MOV_MODE = "MOV",
}

export enum RETIME_EXPORT_MODES {
  MOV_MODE = "MOV",
}

export enum SMART_VECTORS_EXPORT_MODES {
  EXR_MODE = "EXR",
}

export enum TRACKING_EXPORT_MODES {
  ALL_MODE = "ALL",
}

export enum TIME_RANGE {
  all_time = "all_time",
  today = "today",
  last_week = "last_week",
  last_30_days = "last_30_days",
}

export enum WINDOW_EVENTS {
  ANNOTATE = "annotate",
  GET_CURRENT_FRAME = "getCurrentFrame",
  CURRENT_FRAME_REPLY = "currentFrameReply",
  SHOW_PLAN_TAG = "showPlanTag",
  HIDE_PLAN_TAG = "hidePlanTag",
  SMART_VECTORS_ADD_ROI = "smartVectorsAddRoi",
}

export const DEMO_URLS = {
  trackiongStepOne:
    "https://ssai-public-assets.s3.us-east-2.amazonaws.com/admin-public-media/demo/tracking_step_1.mp4",
  trackingStepTwo:
    "https://ssai-public-assets.s3.us-east-2.amazonaws.com/admin-public-media/demo/tracking_step_2.mp4",
  smartVectorsRoiGuide:
    "https://ssai-public-assets.s3.us-east-2.amazonaws.com/admin-public-media/demo/ROI.mp4",
};

export enum PLANS {
  "FREE" = "Free",
  "LITE" = "Lite",
  "STARTER" = "Starter",
  "PRO" = "Pro",
}

export enum SHOT_SOURCES {
  HS = "HS",
  SS = "SS",
}
